module.exports = __webpack_public_path__ + "static/media/cancer-module.436c25e1.png";